import { dataSelector } from '../config/config';

export default (dataKey = null, dataDefault = '') => {
    if (!dataKey) {
        return dataDefault;
    }

    const dataObject = document.querySelector(dataSelector);
    let data = dataDefault;

    if (dataObject.hasAttribute(dataKey)) {
        data = dataObject.getAttribute(dataKey);
    }

    return data;
};
